var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLbottomExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 425,
    viewBox: "0 0 145 425",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.478 245.938C132.704 293.602 94.5285 340.458 61.7777 375.199C30.0843 408.818 -10.6189 401.21 -56.428 407.23C-105.98 413.742 -150.662 439.378 -183.444 401.654C-214.845 365.519 -139.59 328.489 -138.253 280.636C-137.099 239.334 -197.156 181.329 -176.289 145.667C-149.977 100.698 -107.183 19.003 -55.8585 10.0357C-0.761977 0.409303 5.67906 98.1124 45.1451 137.745C82.8087 175.567 138.581 192.652 135.478 245.938Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.945 249.078C116.444 292.048 82.0297 334.289 52.5054 365.608C23.9344 395.916 -12.7589 389.057 -54.0552 394.485C-98.7251 400.355 -139.006 423.466 -168.558 389.457C-196.865 356.881 -129.025 323.498 -127.819 280.358C-126.779 243.123 -180.92 190.832 -162.109 158.682C-138.388 118.142 -99.8103 44.4924 -53.5424 36.4084C-3.87374 27.7301 1.93292 115.811 37.511 151.54C71.4642 185.637 121.742 201.039 118.945 249.078Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.968 250.773C105.656 290.498 73.8462 329.549 46.5561 358.504C20.1472 386.523 -13.7698 380.182 -51.9414 385.199C-93.2313 390.626 -130.464 411.992 -157.781 380.55C-183.946 350.433 -121.239 319.572 -120.125 279.689C-119.164 245.266 -169.209 196.921 -151.821 167.199C-129.896 129.72 -94.2376 61.6322 -51.4705 54.1589C-5.56008 46.1364 -0.192006 127.567 32.6944 160.598C64.0788 192.122 110.552 206.361 107.968 250.773Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.2524 251.33C91.2799 285.287 64.1166 318.668 40.8126 343.417C18.261 367.367 -10.7039 361.945 -43.3016 366.231C-78.5623 370.869 -110.358 389.13 -133.687 362.253C-156.033 336.508 -102.484 310.13 -101.534 276.037C-100.715 246.612 -143.454 205.285 -128.607 179.879C-109.885 147.843 -79.4364 89.6425 -42.9143 83.2562C-3.7079 76.4005 0.880013 146.008 28.966 174.245C55.7692 201.193 95.4575 213.367 93.2524 251.33Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0823 256.567C81.2816 287.496 56.509 317.902 35.2563 340.445C14.6897 362.261 -11.7234 357.324 -41.45 361.231C-73.605 365.456 -102.601 382.092 -123.873 357.612C-144.25 334.164 -95.4158 310.135 -94.5478 279.082C-93.7987 252.281 -132.771 214.642 -119.23 191.5C-102.155 162.319 -74.3855 109.307 -41.0801 103.488C-5.32679 97.2412 -1.14713 160.641 24.4632 186.359C48.9039 210.902 85.0954 221.989 83.0823 256.567Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.0687 259.012C67.4976 285.976 45.8913 312.484 27.3552 332.138C9.41747 351.157 -13.6189 346.854 -39.5452 350.26C-67.5896 353.945 -92.8786 368.448 -111.431 347.107C-129.202 326.666 -86.6109 305.716 -85.8533 278.645C-85.1994 255.28 -119.189 222.466 -107.379 202.292C-92.4861 176.851 -68.2652 130.635 -39.2175 125.561C-8.03488 120.115 -4.39081 175.387 17.9449 197.807C39.2606 219.203 70.8251 228.867 69.0687 259.012Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2664 262.543C59.8331 287.128 40.1267 311.298 23.2205 329.218C6.86007 346.559 -14.1502 342.636 -37.7964 345.742C-63.3743 349.102 -86.4395 362.326 -103.36 342.868C-119.568 324.23 -80.722 305.129 -80.0306 280.446C-79.4339 259.142 -110.433 229.225 -99.6616 210.83C-86.0785 187.635 -63.9871 145.495 -37.494 140.869C-9.05376 135.902 -5.73104 186.298 14.6399 206.739C34.0806 226.247 62.8689 235.058 61.2664 262.543Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8084 269.419C34.8002 286.722 20.9357 303.733 9.04115 316.345C-2.46934 328.55 -17.2516 325.788 -33.8884 327.974C-51.8843 330.338 -68.1121 339.645 -80.0173 325.95C-91.4209 312.833 -64.0902 299.389 -63.6041 282.017C-63.1845 267.024 -84.9954 245.967 -77.4168 233.021C-67.8604 216.695 -52.318 187.038 -33.6783 183.782C-13.6686 180.287 -2.66655 205.045 11.6662 219.432C25.3443 233.162 36.9355 250.075 35.8084 269.419Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1497 271.651C23.3445 285.562 12.238 299.235 2.7093 309.372C-6.51171 319.182 -18.2647 320.969 -31.6864 318.715C-35.7494 316.988 -36.3997 317.023 -40.9683 311.751C-50.1074 301.204 -55.8898 295.731 -55.5028 281.765C-55.1688 269.711 -72.6479 252.78 -66.5774 242.373C-58.9227 229.25 -46.4737 205.41 -31.5391 202.796C-15.5068 199.989 -6.68775 219.894 4.79847 231.462C15.7601 242.502 25.05 256.1 24.1497 271.651Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7666 269.637C11.1825 279.931 3.05299 290.044 -3.92228 297.542C-10.6723 304.797 -19.2803 306.115 -29.1121 304.441C-32.0889 303.162 -32.5651 303.188 -35.9137 299.284C-42.6121 291.475 -46.8498 287.423 -46.5721 277.089C-46.3324 268.169 -59.1422 255.633 -54.7001 247.934C-49.0987 238.226 -39.99 220.59 -29.0519 218.661C-17.31 216.591 -10.8421 231.324 -2.42409 239.889C5.60948 248.063 12.4196 258.13 11.7666 269.637Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.123006 267.215C-0.22137 273.347 -5.03721 279.371 -9.16948 283.836C-13.1683 288.158 -18.2692 288.941 -24.0958 287.942C-25.8601 287.18 -26.1423 287.195 -28.1274 284.869C-32.0982 280.216 -37.0001 277.642 -38.1639 274.567C-39.3276 271.491 -42.3748 272.076 -39.269 254.275C-35.9512 248.492 -30.5564 237.987 -24.0749 236.84C-17.1169 235.609 -13.2815 244.387 -8.29153 249.491C-3.52941 254.362 0.508007 260.36 0.123006 267.215Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLbottomExperience);
export default __webpack_public_path__ + "static/media/Lbottom-Experience.5926eb291b298137b90e245a62d5158f.svg";
export { ForwardRef as ReactComponent };